import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[panelMenuAriaFix]',
  standalone:false

})
export class PanelMenuAriaFixDirective
  implements AfterViewInit, OnDestroy
{
  private observer!: MutationObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    // Small delay to allow PrimeNG initial render
    setTimeout(() => {
      this.attachObserver();
      this.fixAria();
    }, 10);
  }

  private attachObserver(): void {
    const panelMenu = this.el.nativeElement;

    if (!panelMenu) return;

    this.observer = new MutationObserver(() => {
      this.fixAria();
    });

    this.observer.observe(panelMenu, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-controls']
    });
  }

  private fixAria(): void {
    const headers = this.el.nativeElement.querySelectorAll(
      '.p-panelmenu-header[aria-controls]'
    );

    headers.forEach((header: Element) => {
      const id = header.getAttribute('aria-controls');

      if (id && !document.getElementById(id)) {
        header.removeAttribute('aria-controls');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
